import React from "react";

export default function HelloAssoWidget({ url, height = 750 }) {
  const ref = React.useRef(null);
  React.useEffect(() => {
    const onMsg = (e) => {
      const h = e.data && e.data.height;
      if (h && ref.current && h > parseFloat(ref.current.height || 0)) {
        ref.current.height = h + "px";
      }
    };
    window.addEventListener("message", onMsg);
    return () => window.removeEventListener("message", onMsg);
  }, []);
  return (
    <iframe
      ref={ref}
      title="Billetterie HelloAsso Heel'Events"
      src={url}
      data-testid="helloasso-widget"
      style={{ width: "100%", height: `${height}px`, border: "none" }}
      allowTransparency={true}
      scrolling="auto"
    />
  );
}
